import platform from 'platform';

function getBrowserInfo(): string {
  const platformString = platform.toString();
  const browser = `${document.documentElement.clientWidth} x ${document.documentElement.clientHeight}`;
  const screen = `${window.screen.width} x ${window.screen.height}`;

  return `${platformString} | browser: ${browser} | screen ${screen}`;
}

export { getBrowserInfo };
